// removed by extract-text-webpack-plugin
module.exports = {"MyMazdaServiceRequest":"MyMazdaServiceRequest__MyMazdaServiceRequest___27gYD","MyMazdaServiceRequestForm":"MyMazdaServiceRequest__MyMazdaServiceRequestForm___30Yeq"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/MyMazdaServiceRequest/MyMazdaServiceRequest.less
// module id = 1187
// module chunks = 0 1